import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['expensePeriodUnit', 'splitEvenly', 'index', 'amount']);
  const modifyExpenseData = `modifyExpenseData(input: ${dataCreate})`;
  return gql`
  mutation {
    ${modifyExpenseData} {
      id
    }
  }
`;
};
